import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { PlainLayout } from 'Layouts';
import { formatDateRange, timestampToDate } from 'Utils/Format';
import { tealiumTrackEvent, trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { fetchPayments } from 'State/Payments/PaymentActions';
import { Invoice } from 'Features/Invoice/Invoice';
import { getDiscountDisplayName } from 'Utils/Subscriptions';

export function InvoiceComponent({
  payments: { hasPayments, orders, isSuccess },
  user,
  fetchPayments,
  entitlementId,
  params,
}) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isSuccess) {
      fetchPayments(entitlementId);
    }
    tealiumTrackEvent(TRACKING_ENUMS.EVENT_VIEW_INVOICE_SELECTED, {
      button_location: 'my account',
      button_text: 'View',
    });
    trackEvent(TRACKING_ENUMS.EVENT_ACCOUNT_SETTING_INVOICE_VIEWED, {
      page_item_title: 'View',
    });
  }, [fetchPayments, entitlementId, isSuccess]);

  const filterPaymentsByInvoice = (invoiceId) => {
    let invoiceData;
    if (invoiceId && isSuccess && hasPayments) {
      const payment = orders.find(({ paymentID }) => Number(paymentID) === Number(invoiceId));
      if (payment) {
        const { paymentID, orderProductInfo = [], paymentsInfo, totalTaxCharged = 0 } = payment;
        const productInfoItem = orderProductInfo.find((o) => o.appId);
        const { displayName, startDate, endDate, retailPrice, chargedPrice } = productInfoItem;
        const { hasDiscounts, discountsDesc, discountsAmount } = getDiscountDisplayName(productInfoItem);

        const [{ receivedDate = 0, cardType, creditCardNumber, amount, paymentType, email = '', applePayID = '' }] =
          paymentsInfo;
        const totalCharged = amount < 0 ? `-$${(amount * -1).toFixed(2)}` : `$${amount.toFixed(2)}`;
        const billDate = timestampToDate(receivedDate, 2);
        const billingPeriod = formatDateRange(startDate, endDate);

        invoiceData = {
          invoiceId: paymentID,
          hasDiscounts,
          displayName,
          billDate,
          billingPeriod,
          cardType,
          cardNumber: creditCardNumber,
          paymentType,
          paypalEmail: email,
          applePayID,
          retailPrice: retailPrice.toFixed(2),
          chargedPrice: chargedPrice.toFixed(2),
          totalCharged,
          discountsDesc,
          discountsAmount: discountsAmount.toFixed(2),
          totalTaxCharged: totalTaxCharged.toFixed(2),
        };
      }
    }
    return invoiceData;
  };

  const invoiceId = params && params.invoiceid;
  const invoice = filterPaymentsByInvoice(invoiceId);
  if (isSuccess && !invoice) {
    // redirect to page not found
    navigate('*');
  }
  return <PlainLayout showLoader={!invoice}>{invoice && <Invoice user={user} invoice={invoice} />}</PlainLayout>;
}

const mapStateToProps = ({
  user,
  payments,
  appConfig: {
    defaultConfig: { entitlementId },
  },
}) => ({
  user,
  payments,
  entitlementId,
});
const mapDispatchToProps = { fetchPayments };

export const InvoiceContainer = connect(mapStateToProps, mapDispatchToProps)(InvoiceComponent);
